/* Order forms: formulário em etapas (réplica do Tally) que envia para o Worker do Notion.
   Estrutura e lógica aqui; textos em order-forms-<idioma>.js. */
(function () {
  'use strict';

  var ISSUE = {
    NEVER_ARRIVED: 'My order never arrived',
    DAMAGED: 'It arrived damaged or faulty',
    WRONG_ITEM: 'I received the wrong item',
    RETURN: 'I changed my mind and want to return it',
    EXCHANGE: 'I want to exchange it for a different size, colour or product',
    CHARGE: "I don't recognise this charge",
    CANCEL: "I want to cancel an order that hasn't shipped yet"
  };
  // Troca: escolhida na pág. 1 e com caminho próprio; o issue_type é preenchido sozinho no envio.
  var EXCHANGE_HELP = 'I want to exchange a product';

  var FORMS = {
    resolution: {
      fields: {
        help_with: { type: 'choice', required: true, options: [EXCHANGE_HELP, 'Where is my order?', 'I want to cancel an order I just placed', "There's a problem with the order I received", 'I want to return something', "I don't recognise a charge from this store"] },
        order_number: { type: 'text', required: true },
        email: { type: 'email', required: true },
        full_name: { type: 'text', required: true },
        postcode: { type: 'text', required: true },
        card_last4: { type: 'text', required: true },
        issue_type: { type: 'choice', required: true, options: [ISSUE.NEVER_ARRIVED, ISSUE.DAMAGED, ISSUE.WRONG_ITEM, ISSUE.RETURN, ISSUE.CHARGE, ISSUE.CANCEL] },
        tracking_status: { type: 'choice', required: true, options: ['No updates for more than 7 days', "Marked as delivered - but I didn't receive it", 'Returned to sender', "I can't find my tracking number"] },
        checked_places: { type: 'multi', required: true, options: ['The mailbox and around the entrance', 'With neighbours or building reception', 'With your local post office or depot', 'Whether someone else at the address received it'] },
        delivery_address: { type: 'longtext', required: true },
        damage_photos: { type: 'files', required: true },
        packaging_photo: { type: 'files', required: true },
        item_usable: { type: 'choice', required: true, options: ['Yes - partially usable', 'No - completely unusable'] },
        damage_description: { type: 'longtext', required: true },
        item_received_photo: { type: 'files', required: true },
        shipping_label_photo: { type: 'files', required: true },
        wrong_what: { type: 'choice', required: true, options: ['Wrong size', 'Wrong colour', 'Completely different product', 'Items missing from my order'] },
        order_vs_received: { type: 'longtext', required: true },
        date_received: { type: 'date', required: true },
        item_condition: { type: 'choice', required: true, options: ['Unopened - still in original packaging', 'Opened but unused', 'Used'] },
        return_reason: { type: 'choice', required: true, options: ["Doesn't fit", 'Not what I expected', 'Arrived later than I needed', 'No longer needed', 'Found it cheaper elsewhere'] },
        return_photo: { type: 'files', required: true },
        exchange_reason: { type: 'choice', required: true, options: ['The item is defective', 'I need a different size', "I'd like a different colour", "I'd like a different model", 'I received the wrong item', "I'd like a different product"] },
        exchange_details: { type: 'longtext', required: true },
        exchange_date_received: { type: 'date', required: true },
        exchange_condition: { type: 'choice', required: true, options: ['Unopened - still in original packaging', 'Opened but unused', 'Used'] },
        exchange_photo: { type: 'files', required: true },
        exchange_packaging_photo: { type: 'files', required: true },
        exchange_confirmations: { type: 'multi', required: true, options: [
          'I confirm the information above is accurate.',
          "I have read and accept the store's Refund Policy."
        ] },
        charge_date: { type: 'date', required: true },
        charge_amount: { type: 'text', required: true },
        statement_descriptor: { type: 'text', required: true },
        household_use: { type: 'choice', required: true, options: ['Yes', 'No', 'Not sure'] },
        statement_screenshot: { type: 'files', required: true },
        requested_resolution: { type: 'choice', required: true, options: ['Send me a replacement - free of charge', 'Store credit worth 120% of my order', 'Partial refund - and I keep the item', 'Full refund'] },
        bank_contacted: { type: 'choice', required: true, options: ['No', 'Yes'] },
        confirmations: { type: 'multi', required: true, options: [
          'I confirm the information above is accurate and that I am the cardholder or an authorised user of the payment method used for this order.',
          'If this issue is resolved to my satisfaction, I agree to inform my bank to withdraw any dispute I may have filed regarding this charge.',
          "I have read and accept the store's Refund Policy."
        ] }
      },
      // Mesmas páginas e saltos do Tally eqgMDo. A troca (páginas 9 e 10) é caminho próprio:
      // sai da pág. 1, pula a pergunta geral de problema e só pergunta o que é da troca.
      pages: [
        { fields: ['help_with'], title: true },
        { fields: ['order_number', 'email', 'full_name', 'postcode', 'card_last4'], next: function (a) { return a.help_with === EXCHANGE_HELP ? 9 : 2; } },
        { fields: ['issue_type'], next: function (a) {
          var jump = {};
          jump[ISSUE.CANCEL] = 8; jump[ISSUE.CHARGE] = 7; jump[ISSUE.RETURN] = 6; jump[ISSUE.WRONG_ITEM] = 5; jump[ISSUE.DAMAGED] = 4;
          return jump[a.issue_type] !== undefined ? jump[a.issue_type] : 3;
        } },
        { fields: ['tracking_status', 'checked_places', 'delivery_address'], next: function () { return 8; } },
        { fields: ['damage_photos', 'packaging_photo', 'item_usable', 'damage_description'], next: function () { return 8; } },
        { fields: ['item_received_photo', 'shipping_label_photo', 'wrong_what', 'order_vs_received'], next: function () { return 8; } },
        { fields: ['date_received', 'item_condition', 'return_reason', 'return_photo'], next: function () { return 8; } },
        { fields: ['charge_date', 'charge_amount', 'statement_descriptor', 'household_use', 'statement_screenshot'] },
        { fields: ['requested_resolution', 'bank_contacted', 'confirmations'], contact: true, submit: true },
        { fields: ['exchange_reason', 'exchange_details', 'exchange_date_received', 'exchange_condition', 'exchange_photo', 'exchange_packaging_photo'], next: function () { return 10; } },
        { fields: ['exchange_confirmations'], contact: true, submit: true }
      ],
      derive: function (answers) {
        if (answers.help_with === EXCHANGE_HELP) answers.issue_type = ISSUE.EXCHANGE;
      }
    },
    eu: {
      fields: {
        full_name: { type: 'text', required: true },
        email: { type: 'email', required: true },
        order_number: { type: 'text', required: true },
        purchase_date: { type: 'date', required: true },
        received_date: { type: 'date', required: false },
        withdraw_scope: { type: 'choice', required: false, options: ['whole', 'some'] },
        items: { type: 'longtext', required: false },
        reason: { type: 'longtext', required: false }
      },
      pages: [
        { fields: ['full_name', 'email', 'order_number', 'purchase_date', 'received_date', 'withdraw_scope', 'items', 'reason'], title: true, submit: true }
      ]
    }
  };

  var MAX_FILES = 10;
  var MAX_BYTES = 5 * 1024 * 1024;

  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'text') n.textContent = attrs[k];
      else if (k === 'class') n.className = attrs[k];
      else n.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) n.appendChild(c); });
    return n;
  }

  function fmt(s, vars) {
    return String(s).replace(/\{(\w+)\}/g, function (m, k) { return vars[k] !== undefined ? vars[k] : m; });
  }

  // Foto grande do celular vira JPEG menor antes do envio (mantém o limite de 5 MB e o envio rápido).
  function compress(file) {
    if (!/^image\//.test(file.type) || file.type === 'image/gif') return Promise.resolve(file);
    if (file.size < 1.5 * 1024 * 1024 && /jpe?g|png|webp/.test(file.type)) return Promise.resolve(file);
    if (!window.createImageBitmap) return Promise.resolve(file);
    return createImageBitmap(file).then(function (bmp) {
      var max = 2000, w = bmp.width, h = bmp.height, s = Math.min(1, max / Math.max(w, h));
      var c = document.createElement('canvas');
      c.width = Math.round(w * s); c.height = Math.round(h * s);
      c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
      return new Promise(function (resolve) {
        c.toBlob(function (blob) {
          if (!blob || blob.size >= file.size) return resolve(file);
          resolve(new File([blob], file.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' }));
        }, 'image/jpeg', 0.85);
      });
    }).catch(function () { return file; });
  }

  function OrderForm(root) {
    this.root = root;
    this.kind = root.getAttribute('data-order-form');
    this.def = FORMS[this.kind];
    var lang = root.getAttribute('data-lang') || 'en';
    var all = window.OrderFormsI18n || {};
    this.lang = all[lang] ? lang : 'en';
    this.t = all[this.lang] || all.en;
    this.tEn = all.en;
    this.answers = {};
    this.files = {};
    this.history = [0];
    this.started = Date.now();
    this.render();
  }

  OrderForm.prototype.text = function (path) {
    var get = function (src) { return path.split('.').reduce(function (o, k) { return o && o[k]; }, src); };
    var v = get(this.t);
    return v !== undefined ? v : get(this.tEn);
  };

  OrderForm.prototype.label = function (key) { return this.text(this.kind + '.fields.' + key); };

  // Busca por índice, não por caminho: há opções com ponto no texto (as confirmações).
  OrderForm.prototype.optionLabel = function (key, value) {
    var kind = this.kind;
    var look = function (src) {
      var o = src && src[kind] && src[kind].options;
      if (!o) return undefined;
      if (o[key] && typeof o[key] === 'object' && o[key][value] !== undefined) return o[key][value];
      return typeof o[value] === 'string' ? o[value] : undefined;
    };
    var v = look(this.t);
    if (v === undefined) v = look(this.tEn);
    return v !== undefined ? v : value;
  };

  OrderForm.prototype.submitLabel = function () { return this.text(this.kind + '.submit') || this.text('ui.submit'); };

  OrderForm.prototype.current = function () { return this.history[this.history.length - 1]; };

  OrderForm.prototype.render = function () {
    var self = this, idx = this.current(), page = this.def.pages[idx];
    this.root.innerHTML = '';
    var form = el('form', { class: 'of__form', novalidate: '' });
    if (page.title) form.appendChild(el('h1', { class: 'of__title', text: this.text(this.kind + '.title') }));
    var intro = page.title && this.text(this.kind + '.intro');
    if (intro) form.appendChild(el('p', { class: 'of__intro', text: intro }));

    page.fields.forEach(function (key) { form.appendChild(self.renderField(key)); });

    if (page.contact) {
      var store = this.root.getAttribute('data-store-name');
      var email = this.root.getAttribute('data-support-email');
      if (email) form.appendChild(el('p', { class: 'of__contact', text: fmt(this.text(this.kind + '.contact'), { store: store, email: email }) }));
    }

    // Isca para robôs: invisível para pessoas.
    var trap = el('div', { class: 'of__trap', 'aria-hidden': 'true' }, [
      el('label', { text: 'Website' }, [el('input', { type: 'text', name: 'website', tabindex: '-1', autocomplete: 'off' })])
    ]);
    form.appendChild(trap);

    var error = el('p', { class: 'of__form-error', role: 'alert' });
    form.appendChild(error);

    var nav = el('div', { class: 'of__nav' });
    if (this.history.length > 1) {
      var back = el('button', { type: 'button', class: 'of__back', text: this.text('ui.back') });
      back.addEventListener('click', function () { self.collect(); self.history.pop(); self.render(); self.scrollTop(); });
      nav.appendChild(back);
    }
    var nextBtn = el('button', { type: 'submit', class: 'of__next button button--primary', text: page.submit ? this.submitLabel() : this.text('ui.next') });
    nav.appendChild(nextBtn);
    form.appendChild(nav);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.collect();
      if (!self.validate(page)) return;
      if (page.submit) return self.send(nextBtn, error);
      var to = page.next ? page.next(self.answers) : idx + 1;
      self.history.push(to);
      self.render();
      self.scrollTop();
    });

    this.form = form;
    this.root.appendChild(form);
  };

  OrderForm.prototype.renderField = function (key) {
    var self = this, f = this.def.fields[key], id = 'of-' + this.kind + '-' + key;
    var wrap = el('div', { class: 'of__field of__field--' + f.type, 'data-key': key });
    var titleTag = (f.type === 'choice' || f.type === 'multi' || f.type === 'files') ? 'p' : 'label';
    var title = el(titleTag, { class: 'of__label', text: this.label(key) });
    if (titleTag === 'label') title.setAttribute('for', id);
    if (f.required) title.appendChild(el('span', { class: 'of__req', text: ' *', 'aria-hidden': 'true' }));
    wrap.appendChild(title);
    var value = this.answers[key];

    if (f.type === 'choice' || f.type === 'multi') {
      var group = el('div', { class: 'of__options', role: f.type === 'choice' ? 'radiogroup' : 'group' });
      f.options.forEach(function (opt, i) {
        var input = el('input', { type: f.type === 'choice' ? 'radio' : 'checkbox', name: key, value: opt, id: id + '-' + i });
        if (f.type === 'choice' ? value === opt : (value || []).indexOf(opt) > -1) input.checked = true;
        group.appendChild(el('label', { class: 'of__option', for: id + '-' + i }, [input, el('span', { text: self.optionLabel(key, opt) })]));
      });
      wrap.appendChild(group);
    } else if (f.type === 'files') {
      wrap.appendChild(this.renderFiles(key, id));
    } else {
      var input = f.type === 'longtext' ? el('textarea', { id: id, name: key, rows: '4' })
        : el('input', { id: id, name: key, type: f.type === 'email' ? 'email' : f.type === 'date' ? 'date' : 'text', autocomplete: { email: 'email', full_name: 'name', postcode: 'postal-code' }[key] || 'off' });
      input.className = 'of__input';
      var hint = this.text(this.kind + '.placeholders.' + key);
      if (hint) input.setAttribute('placeholder', hint);
      if (value) input.value = value;
      wrap.appendChild(input);
    }
    wrap.appendChild(el('p', { class: 'of__error', role: 'alert' }));
    return wrap;
  };

  OrderForm.prototype.renderFiles = function (key, id) {
    var self = this;
    var box = el('div', { class: 'of__files' });
    var input = el('input', { id: id, type: 'file', accept: 'image/*,application/pdf', multiple: '', class: 'of__file-input' });
    var drop = el('label', { class: 'of__drop', for: id }, [
      el('span', { class: 'of__drop-main', text: this.text('ui.files_choose') }),
      el('span', { class: 'of__drop-hint', text: this.text('ui.files_hint') })
    ]);
    var list = el('ul', { class: 'of__file-list' });
    var refresh = function () {
      list.innerHTML = '';
      (self.files[key] || []).forEach(function (file, i) {
        var rm = el('button', { type: 'button', class: 'of__file-remove', text: self.text('ui.remove') });
        rm.addEventListener('click', function () { self.files[key].splice(i, 1); refresh(); });
        list.appendChild(el('li', {}, [el('span', { text: file.name }), rm]));
      });
    };
    var add = function (fileList) {
      var err = box.parentNode.querySelector('.of__error');
      err.textContent = '';
      var current = self.files[key] || [];
      var incoming = Array.prototype.slice.call(fileList);
      if (current.length + incoming.length > MAX_FILES) { err.textContent = self.text('ui.too_many'); return; }
      Promise.all(incoming.map(compress)).then(function (ready) {
        for (var i = 0; i < ready.length; i++) {
          if (!/^image\//.test(ready[i].type) && ready[i].type !== 'application/pdf') { err.textContent = self.text('ui.file_type'); return; }
          if (ready[i].size > MAX_BYTES) { err.textContent = self.text('ui.too_big'); return; }
        }
        self.files[key] = current.concat(ready);
        refresh();
      });
    };
    input.addEventListener('change', function () { add(input.files); input.value = ''; });
    ['dragover', 'dragenter'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files) add(e.dataTransfer.files); });
    box.appendChild(input);
    box.appendChild(drop);
    box.appendChild(list);
    refresh();
    return box;
  };

  OrderForm.prototype.collect = function () {
    var self = this, page = this.def.pages[this.current()];
    page.fields.forEach(function (key) {
      var f = self.def.fields[key];
      if (f.type === 'files') return;
      if (f.type === 'choice') {
        var c = self.form.querySelector('input[name="' + key + '"]:checked');
        self.answers[key] = c ? c.value : '';
      } else if (f.type === 'multi') {
        self.answers[key] = Array.prototype.map.call(self.form.querySelectorAll('input[name="' + key + '"]:checked'), function (i) { return i.value; });
      } else {
        self.answers[key] = (self.form.querySelector('[name="' + key + '"]').value || '').trim();
      }
    });
  };

  OrderForm.prototype.validate = function (page) {
    var self = this, firstBad = null;
    page.fields.forEach(function (key) {
      var f = self.def.fields[key], v = self.answers[key], msg = '';
      var wrap = self.form.querySelector('[data-key="' + key + '"]');
      var empty = f.type === 'files' ? !(self.files[key] || []).length : f.type === 'multi' ? !(v || []).length : !v;
      if (f.required && empty) msg = self.text('ui.required');
      else if (!empty && f.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) msg = self.text('ui.email');
      wrap.querySelector('.of__error').textContent = msg;
      wrap.classList.toggle('has-error', !!msg);
      if (msg && !firstBad) firstBad = wrap;
    });
    if (firstBad) { firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' }); return false; }
    return true;
  };

  OrderForm.prototype.send = function (btn, errorEl) {
    var self = this;
    var visited = {};
    this.history.forEach(function (i) { self.def.pages[i].fields.forEach(function (k) { visited[k] = true; }); });
    var answers = {}, data = new FormData();
    Object.keys(visited).forEach(function (k) {
      var f = self.def.fields[k];
      if (f.type === 'files') (self.files[k] || []).forEach(function (file) { data.append('file_' + k, file, file.name); });
      else if (self.answers[k] !== undefined && self.answers[k] !== '') answers[k] = self.answers[k];
    });
    if (this.def.derive) this.def.derive(answers);
    data.append('form', this.kind);
    data.append('store', this.root.getAttribute('data-store'));
    data.append('store_name', this.root.getAttribute('data-store-name'));
    data.append('lang', this.lang);
    data.append('answers', JSON.stringify(answers));
    data.append('website', this.form.querySelector('input[name="website"]').value);
    data.append('elapsed_ms', String(Date.now() - this.started));
    data.append('page_url', location.origin + location.pathname);

    btn.disabled = true;
    btn.textContent = this.text('ui.sending');
    errorEl.textContent = '';
    fetch(this.root.getAttribute('data-endpoint'), { method: 'POST', body: data })
      .then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.error || 'server');
        self.thanks();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = self.submitLabel();
        errorEl.textContent = self.text('ui.error');
      });
  };

  OrderForm.prototype.thanks = function () {
    var box = el('div', { class: 'of__thanks', role: 'status' });
    (this.text(this.kind + '.thanks') || []).forEach(function (line, i) {
      box.appendChild(el(i === 0 ? 'h2' : 'p', { class: i === 0 ? 'of__thanks-title' : 'of__thanks-text', text: line }));
    });
    this.root.innerHTML = '';
    this.root.appendChild(box);
    this.scrollTop();
  };

  OrderForm.prototype.scrollTop = function () {
    var top = this.root.getBoundingClientRect().top + window.pageYOffset - 100;
    if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
  };

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-order-form]:not([data-ready])'), function (root) {
      root.setAttribute('data-ready', '');
      new OrderForm(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
